export default [
  {value: '1', label: '直连设备'},
  {value: '2', label: '网关子设备'},
  {value: '3', label: '网关设备'}
]
